import * as types from '../dashboardActionTypes';


const deviceGroupsReducer = (state = [], action) => {
    switch (action.type) {
        case types.LOAD_DEVICE_GROUPS_SUCCESS:
            return [...action.deviceGroups];
        
        default:
            return state;
    }
};

export default deviceGroupsReducer;


// WEBPACK FOOTER //
// ./src/dashboard/reducers/deviceGroupsReducer.js